var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import merge from 'lodash.merge';
import React, { useCallback } from 'react';
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { BaseInput } from '../../atoms/BaseInput';
import { Translation } from '../../atoms/Translation';
import { InputGroupWrapper } from './styled';
export var InputGroup = function (_a) {
    var design = _a.design, active = _a.active, onOptionClick = _a.onOptionClick, props = __rest(_a, ["design", "active", "onOptionClick"]);
    var _b = useDesign(design), schema = _b.schema, components = _b.components, config = _b.config;
    var mergedConfig = merge({}, config, props);
    var input = components.input, label = components.label;
    var inputs = Object.keys(mergedConfig.inputs);
    var handleOptionClick = useCallback(function (option) { return onOptionClick && onOptionClick(option); }, [onOptionClick]);
    return (_jsx(InputGroupWrapper, __assign({ schema: schema, "data-design": design }, { children: inputs.map(function (option) {
            var _a = mergedConfig.inputs[option], i18n = _a.i18n, inputProps = __rest(_a, ["i18n"]);
            var activeOption = option === active;
            return (_jsxs(React.Fragment, { children: [_jsx(BaseInput, __assign({ design: input, checked: activeOption, onClick: function () { return handleOptionClick(option); } }, mergedConfig, inputProps)), _jsx(FactoryComponent, __assign({ as: "label", htmlFor: option, design: label, active: activeOption, onClick: function () { return handleOptionClick(option); } }, { children: _jsx(Translation, __assign({}, i18n)) }))] }, option));
        }) })));
};
InputGroup.displayName = 'InputGroup';
